<template>
  <el-card
    class="box-card experience-wrapper--section-is_for_me"
    shadow="never"
  >
    <div class="experience-wrapper--section-is_for_me-content">
      <div class="section section-is_for_me">
        <div
          v-for="(item, i) in exForMe"
          :key="`is_for_me-${i}`"
          class="wrapper-is_for_me"
        >
          <div class="cardheader"></div>
          <div class="avatar">
            <LadImage :src="item.resource" :alt="item.style" />
          </div>
          <section>
            <div class="section-top">
              <h3 class="style">{{ item.style }}</h3>
              <p class="title">{{ getDatatypeLabel(item) }}</p>
            </div>
            <p class="section-description">{{ item.description }}</p>
          </section>
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'LadTabForMe',
  components: {
    LadImage: () =>
      import(
        /* webpackChunkName: "lad-image" */ '@/components/frontends/Image/index'
      ),
  },
  data() {
    return {
      base: 'experience.is_for_me',
    }
  },
  computed: {
    ...mapGetters('device', ['isMobile']),
    ...mapState('experience', {
      exForMe: 'for_me',
    }),
  },
  methods: {
    // eslint-disable-next-line camelcase
    getDatatypeLabel({ type, type_data }) {
      switch (type) {
        case 'text':
          return type_data.name
        case 'range':
          // eslint-disable-next-line no-case-declarations
          const min = type_data.start ? type_data.start : 'N/A'
          // eslint-disable-next-line no-case-declarations
          const max = type_data.end ? type_data.end : 'N/A'

          return `${this.$tc('general.min', min, {
            min,
          })} / ${this.$tc('general.max', max, { max })}`
        default:
          return ''
      }
    },
  },
}
</script>

<style lang="scss">
.experience-wrapper--section-is_for_me {
  .section-is_for_me {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;

    .wrapper-is_for_me {
      display: flex;
      flex-direction: column;
      border: 1px solid #ebeef2;

      .cardheader {
        padding-bottom: 90px;
        background-color: #ebeef2;
        position: relative;
      }
      .avatar {
        position: relative;
        top: -50px;
        margin-bottom: -50px;
        margin-left: 20px;

        img {
          width: 100px;
          height: 100px;
          max-width: 100px;
          max-height: 100px;
          border-radius: 50%;
          border: 5px solid rgba(255, 255, 255, 0.5);
          vertical-align: middle;
          background-color: #f9f9f9;
        }
      }

      section {
        flex: 1;
        display: flex;
        flex-direction: column;
        padding-top: 0;

        .section-top {
          text-align: right;
          margin-top: -40px;
        }

        .style {
          margin: 0;
          font-weight: 700;
        }
        .title {
          color: #6ec12a;
        }
      }
    }
  }

  @media screen and (max-width: 750px) {
    .section-is_for_me {
      grid-template-columns: 1fr;
      grid-gap: 0;

      .wrapper-is_for_me {
        border: 0;

        .cardheader {
          background-color: #f3f3f3;
        }
      }
    }

    .el-card__body {
      padding: 0;
    }
  }
}
</style>
